import { useQuery } from '@tanstack/react-query';

import { BesluitSchema } from '@/api/generated/digiVAPI.schemas';
import { createInString } from '@/utils/createInString';

import { useBesluitGrondslag } from '../besluitGrondslag';

interface BesluitGrondslagQueryOptions {
  besluiten: BesluitSchema[];
}

const queryOptions = (besluiten: BesluitGrondslagQueryOptions) => {
  return useBesluitGrondslag.getOptions({
    page: 1,
    size: 100,
    filter: [
      {
        field: 'Besluit',
        op: 'in',
        value: createInString(besluiten.besluiten.map((besluit) => besluit.ID)),
      },
    ],
  });
};

const useAllGrondslagenInBesluiten = (params: BesluitGrondslagQueryOptions) =>
  useQuery({ ...queryOptions(params), enabled: !!params.besluiten.length });

useAllGrondslagenInBesluiten.queryOptions = queryOptions;

export { useAllGrondslagenInBesluiten };
